/**
 * Created by richardlovejoy on 2/9/17.
 */
import DebugUtils from './debug/DebugUtils';
import GoogleFontsManager from './display/GoogleFontsManager';
import TimeHelpers from './misc/TimeHelpers';
import DisplayHelpers from './misc/DisplayHelpers';
import AnimHelpers from './misc/AnimHelpers';
import CurrencyHelpers from './misc/CurrencyHelpers';
import TextHelpers from './misc/TextHelpers';
import FBHelpers from './misc/FBHelper';

const PhaserUtils = {

  init(game, config) {

    // init all the helpers
    if (config.debug) {
      DebugUtils.init(game, config);
    }

    GoogleFontsManager.init(game);
    TimeHelpers.init(game);
    DisplayHelpers.init(game);
    AnimHelpers.init(game);
    CurrencyHelpers.init(game);
    TextHelpers.init(game);

    if (config.facebookAppId) {
      FBHelpers.init(config.facebookAppId, config.facebookApiVersion);
    }

  }
};

function isIOS() {
  let isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  return isIOS;
}

export default PhaserUtils;
export {isIOS};




// WEBPACK FOOTER //
// ./app/src/utils/PhaserUtils.js